/**
 * KTUI - Free & Open-Source Tailwind UI Components by Keenthemes
 * Copyright 2025 by Keenthemes Inc
 */

export { KTSticky } from './sticky';
export type { KTStickyConfigInterface, KTStickyInterface } from './types';
